import React from "react";
import styled from "styled-components";
import { narrativeViewerStyles } from "../Feasibility/FeasibilityEditor/narrativeStyles";
import { withTableWrappers } from "../Feasibility/FeasibilityEditor/narrativeHtml";

const Wrap = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fafafa;
  margin-bottom: 24px;

  ${narrativeViewerStyles}
`;

export default function SiteNarrativeViewer({ html }) {
  if (!html) return null;
  return <Wrap dangerouslySetInnerHTML={{ __html: withTableWrappers(html) }} />;
}
